import type { Router } from 'vue-router'
import nProgress from 'nprogress'
import { createAuthGuard } from './auth'

/**
 * 创建并注册所有路由守卫
 */
export default (router: Router) => {
  router.beforeEach((to, from) => {
    console.info('[🕹 vue-router=>beforeEach]\n', from, '\n', to)
    nProgress.start()
  })

  createAuthGuard(router)

  router.afterEach((to, from) => {
    console.info('[🕹 vue-router=>afterEach]\n', from, '\n', to)
    nProgress.done()
  })
}
